import React from 'react'

export const TextField = ({
  label,
  hint,
  error,
  className = '',
  inputClassName = '',
  hintClassName = '',
  invalid = false,
  ...props
}) => {
  // Определяем классы для input
  const inputClasses = [
    'w-full rounded-lg border px-3 py-2 bg-white/90 dark:bg-slate-700/90 text-gray-900 dark:text-gray-100 transition-colors',
    inputClassName || className,
    invalid || error
      ? 'border-red-500 focus:ring-red-500 focus:border-red-500'
      : 'border-gray-300 dark:border-slate-600 focus:ring-indigo-500 focus:border-indigo-500'
  ].filter(Boolean).join(' ')

  // Определяем классы для hint
  const hintClasses = [
    'text-xs text-slate-500 dark:text-slate-400',
    hintClassName
  ].filter(Boolean).join(' ')

  return (
    <div className="space-y-1">
      {label && <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">{label}</label>}
      <input
        {...props}
        className={inputClasses}
      />
      {hint && !error && <p className={hintClasses}>{hint}</p>}
      {error && <p className="text-xs text-red-600 dark:text-red-400 mt-1">{error}</p>}
    </div>
  )
}